import PageLayout from "../../../../components/page/PageLayout";
import {Breadcrumb, BreadcrumbNavigation} from "../../navigation/Breadcrumb";
import Pagination from "../../navigation/Pagination";
import ProductFilter from "../../product/ProductFilter";
import ProductLayout from "../../product/ProductLayout";
import useProductIDPage from "../../../services/state/product/useProductIDPage";
import {useParams} from "react-router-dom";
import usePageBreadcrumbTracker from "../../../services/state/navigation/usePageBreadcrumbTracker";
import useSolrFilters from "../../../services/state/product/useSolrFilters";
import FilterUrl from "../../../logic/filter/filterUrl";
import useValueChangeListener from "../../../services/state/general/useValueChangeListener";
import OrderBy from "../../../logic/filter/orderBy";
import React, {useState} from "react";
import ProductDisplayLayoutOptions
    from "../../../sales/product/productDisplay/productDisplayOptions/ProductDisplayLayoutOption";
import ProductDisplayPageSizeOption
    from "../../../sales/product/productDisplay/productDisplayOptions/ProductDisplayPageSizeOption";
import {MobilePageNav, MobilePageNavItem} from "../../navigation/mobilePageNav/MobilePageNav";
import ReactiveNavContainer from "../../navigation/ReactiveNavDrawer";
import useLayoutPref from "../../../layout/useLayoutPref";
import Platform from "../../../logic/platform/platform";
import DiscountController from "../../../pricing/discount/DiscountController";

const getFilterUrl = (filter, filterParam) => {
    if(filter) {
        return "/" + filter;
    } else if(filterParam) {
        return "/" + filterParam;
    } else {
        return "";
    }
}

const PageProductID = ({ requiresSignIn=true, loading, breadcrumbTrail, productIDs, getProductList, onPageChange, getNav }) => {

    const { pageNo : pageNoParam, filter : filterParam } = useParams();
    const [ layout, setLayout ] =  useLayoutPref();
    const [ pageSize, setPageSize ] = useState(20);
    const [ showFilterDrawer, setShowFilterDrawer ] = useState(false);

    const pageNo = pageNoParam && !isNaN(Number(pageNoParam)) ? Number(pageNoParam) : 1;
    useValueChangeListener(() => window.scrollTo(0,0), [ pageNo, filterParam ]);

    const {
        getFilters,
        filters
    } = useSolrFilters();

    const {
        loading: productsLoading,
        products,
        pageCount,
    } = useProductIDPage(pageNo, productIDs, filterParam, pageSize);

    const handlePageChange = (pageNo, filter) => {
        onPageChange(pageNo, filter ? filter : "");
    }

    const onPageChangeRequest = (pageNo) => {
        handlePageChange(pageNo, "/" + filterParam);
    }

    const onPageSizeChange = (newSize) => {
        setPageSize(newSize);
        onPageChange(1, "");
    }

    const onFilterApply = (selectedFilters) => {
        const filter = FilterUrl.getUrl(selectedFilters);
        handlePageChange(1, getFilterUrl(filter, filterParam));
    }

    const requestFilters = () => {
        if(productIDs && productIDs.length > 0) {
            getFilters({productIDs});
        }
    }

    const filtersWithOrdering = filters ? {...filters, [OrderBy.ATTRIBUTE_SET.id]: OrderBy.FILTER} : null;
    // usePageBreadcrumbTracker(breadcrumbTrail, [pageNo, filterParam], () => `/clearance/${pageNo}`);
    usePageBreadcrumbTracker(breadcrumbTrail, [pageNo, filterParam], () => getNav ? getNav(pageNo, filterParam) : null);
    useValueChangeListener(requestFilters, productIDs);

    return (
        <PageLayout
            requireSignIn={requiresSignIn}
            headerChildren={
                <MobilePageNav>
                    <MobilePageNavItem onClick={() => setShowFilterDrawer(true)}>
                        Filter
                    </MobilePageNavItem>
                </MobilePageNav>
            }
        >
            <div className="page-content product-content">
                <BreadcrumbNavigation>
                    {breadcrumbTrail.map((crumb, i) =>
                        <Breadcrumb
                            key={i}
                            name={crumb.name}
                            nav={crumb.nav}
                            selected={crumb.selected}
                        />
                    )}
                </BreadcrumbNavigation>
                <ProductLayout>
                    <div className="product-layout-filters">
                        <ReactiveNavContainer
                            display={showFilterDrawer}
                            onHide={() => setShowFilterDrawer(false)}
                        >
                            <DiscountController />
                            <div className="product-layout-filters">
                                <ProductFilter
                                    filters={filtersWithOrdering}
                                    onApply={onFilterApply}
                                    defaultParam={filterParam}
                                >
                                    {!Platform.isMobile() &&
                                        <ProductDisplayLayoutOptions
                                            layout={layout}
                                            onChange={setLayout}
                                        />
                                    }
                                    <ProductDisplayPageSizeOption
                                        pageSize={pageSize}
                                        onChange={onPageSizeChange}
                                    />
                                </ProductFilter>
                            </div>
                        </ReactiveNavContainer>
                    </div>
                    {getProductList(products, productsLoading || loading, layout)}
                </ProductLayout>
                <Pagination
                    currentPage={pageNo}
                    lastPage={pageCount}
                    onPageRequested={onPageChangeRequest}
                    loading={productsLoading || loading}
                />
            </div>
        </PageLayout>
    )
}

export default PageProductID;
